

































































import Job from "@/store/entities/job";
import { Component, Prop, Vue } from "vue-property-decorator";
import Ajax from '../../../lib/ajax';
@Component({})
export default class OccupationEdit extends Vue {
  @Prop()
  editJob!: Job;
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;


  async updateJob() {
  await Ajax.put(
        '/api/services/app/Admin/UpdateJob',this.editJob
      );
      Vue.$toast.success("Kayıt Güncellendi");
      this.closeDialog();
  }
  
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

      occupation: [],
      occupationItems: ["Mühendis", "Şef"], 
      
      city: [],
      cityItems: ["İstanbul", "Ankara"], 

      category: [],
      categoryItems: ["Proje", "Şantiye Şefi"], 

    };
  }

  async created() {
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }

}



  
  
